import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SupportEmailAddress } from 'src/app/helpers/variables/SupportEmailAddress';
import { MatSnackBarService } from 'src/app/services/mat-snack-bar.service';

@Component({
	selector: 'app-contact-dialog',
	templateUrl: './contact-dialog.component.html',
	styleUrls: ['./contact-dialog.component.scss']
})
export class ContactDialogComponent {

	email = SupportEmailAddress;

	constructor(private matSnackBarService:MatSnackBarService,
				private selfDialogRef: MatDialogRef<ContactDialogComponent>) { }

	onSent(sent:boolean) {
		if (sent) {
			this.matSnackBarService.show("success", "¡Mensaje enviado!");
			this.selfDialogRef.close();
		} else {
			this.matSnackBarService.show("error", "No se pudo enviar el mensaje. Intentá nuevamente más tarde");
		}
	}
}